module.exports = __webpack_public_path__ + "img/homePageimg6.a9e454e1.png";